// extracted by mini-css-extract-plugin
module.exports = {"content":"_103a151b99--content--dq171","icon":"_103a151b99--icon--oGuyR","footer":"_103a151b99--footer--oKZfH"};